import { createGrid } from 'ag-grid-community';
import 'ag-grid-enterprise';
import { actionsColumn, sequenceSearchLink, plainText, urlRenderer, fitGridHeight } from './sequence_grid_helpers.js';

; (function () {

  "use strict";
  var SequenceIndex = function () {
    var $toggleButton = $('#toggle-filter');
    var $filterForm = $('#filter-form');

    var initializeTable = function () {
      const eGridDiv = document.querySelector('#myGrid');
      const sequencesDataElement = document.getElementById('sequences-data');
      if (!eGridDiv || !sequencesDataElement) return;

      const rowData = JSON.parse(sequencesDataElement.dataset.json);

      const columnDefs = [
        actionsColumn(),
        {
          headerName: 'Texts', field: 'sequence_text', minWidth: 190, flex: 1.25,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_text'); }
        },
        {
          headerName: 'Creations', field: 'sequence_creation', minWidth: 160, flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_creation'); }
        },
        {
          headerName: 'Completes', field: 'sequence_complete', minWidth: 160, flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_complete'); }
        },
        {
          headerName: 'Lexigrams', field: 'sequence_lexigram', minWidth: 160, flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_lexigram'); }
        },
        {
          headerName: 'Singulars', field: 'sequence_singular', minWidth: 160, flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_singular'); }
        },
        {
          headerName: 'Lenses', field: 'sequence_lense', minWidth: 160, flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_lense'); }
        },
        {
          headerName: 'Description', field: 'description', minWidth: 240, flex: 1.5,
          cellRenderer: plainText
        },
        {
          headerName: 'Url', field: 'url', minWidth: 220, flex: 1.2,
          cellRenderer: urlRenderer
        },
        {
          headerName: 'Reference', field: 'reference', minWidth: 260, flex: 1.5,
          cellRenderer: plainText
        }
      ]

      const gridOptions = {
        columnDefs: columnDefs,
        rowData: rowData,
        defaultColDef: {
          resizable: true,
          sortable: true,
          filter: true,
          suppressMovable: true
        },
        rowHeight: 44,
        suppressMovableColumns: true,
        suppressDragLeaveHidesColumns: true,
        ensureDomOrder: true,
        // Define the context menu with custom options
        getContextMenuItems: function (params) {
          let defaultItems = params.defaultItems;  // Include default items

          // Filter out specific items you want to remove
          defaultItems = defaultItems.filter(item => {
            return item == 'copy';
          });
          // Define custom context menu items
          const customItems = [
            'separator',  // Add a separator
            {
              name: 'Open this entry',
              action: function () {
                window.location.assign('/v2/sequences/' + encodeURIComponent(params.node.data.id));
              },
              icon: '<i class="fas fa-eye"></i>'
            },
            'separator'  // Another separator if needed
          ];

          // Return both default and custom menu items
          return defaultItems.concat(customItems);
        },
      };

      fitGridHeight(eGridDiv, rowData.length, { rowHeight: 44 });
      createGrid(eGridDiv, gridOptions);
    };

    var initializeFilterToggle = function () {
      $toggleButton.on('click', function () {
        var expanded = $filterForm.is(':visible');
        $toggleButton.attr('aria-expanded', expanded ? 'false' : 'true');
        $filterForm.slideToggle();
        $filterForm.find('input:first').focus();
      });
    };

    this.init = function () {
      initializeFilterToggle();
      initializeTable();
    }
  };

  $(document).ready(function () {
    if ($('body').data('controller') === 'sequences' && (($('body').data('action') === 'advanced_search') || ($('body').data('action') === 'index'))) {
      var sequenceIndex = new SequenceIndex();
      sequenceIndex.init();
    }
  });
})();
